// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5922":"66b2b4ea","7539":"ca20d75d","7939":"54516db3","8266":"bda57fb9"}[chunkId] + ".chunk.css";
};